import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import ProjectBmsCase  from "./Project_bms_case";
import ProjectBmsHistory  from "./Project_bms_history";

// 예시 이미지(원하는 파일로 교체 가능)
import banner from "../assets/layout/images/project_bms_banner.jpg";
import customer from "../assets/layout/images/project_bms_logo.png";

const Project_bms = () => {
   const [active, setActive] = useState("case"); // 기본 선택 (구축사례)

  return (
    <>
      <Navbar detail />
      <section className="detail">
        <div className="container-lg" style={{ maxWidth: 1200, paddingTop: 0 }}>
          {/* Breadcrumb */}
          <nav className="mb-3">
            <a href="/#project" className="menu-link me-2">Business</a>
            <span className="text-muted" style={{color: "#fff", fontWeight:"bold"}}>›</span>
            <strong className="menu-title ms-2">교량계측관리</strong>
          </nav>

          {/* Title */}
          <div className="banner">
            <h1 className="detail-title">통합 교량 계측 관리</h1>
            <figure className="banner-figure full-bleed">
              <img 
                className="banner-img" 
                src={banner}
                alt="컨택센터 배너이미지"
              />
            </figure>
          </div>
          {/* Description */}
          <div className="detail-desc">
            아미소프트는 교량 계측 시스템을 직접 개발하고, 실제 교량에 다양한 센서를 설치하여 안정적인 운영까지 수행하고 있습니다. 
            변위·진동·하중 등 주요 데이터를 실시간으로 수집·분석해 구조적 이상을 조기에 감지하며, 안전한 교량 관리와 효율적인 유지보수에 기여한 다수의 구축 사례를 보유하고 있습니다
          </div>

        {/* 버튼 이미지 */}
        <div className="bms-btn-wrap">
          <button
            className={`bms-btn ${active === "case" ? "active" : ""}`}
            onClick={() => setActive("case")}
          >
            <i className="bi bi-filter-square-fill"></i>
            <span>구축사례</span>
          </button>
          <button
            className={`bms-btn ${active === "customer" ? "active" : ""}`}
            onClick={() => setActive("customer")}
          >
            <i className="bi bi-stack"></i>
            <span>주요 고객사</span>
          </button>
          <button
            className={`bms-btn ${active === "history" ? "active" : ""}`}
            onClick={() => setActive("history")}
          >
            <i className="bi bi-clock-fill"></i>
            <span>연혁</span>
          </button>
        </div>

        {/* 하단 콘텐츠 */}
        <div className="bms-detail">
          {active === "case" && <div><ProjectBmsCase /></div>}
          {active === "customer" && 
            <div>
              <img 
                src={customer} alt="주요 고객사" 
                height="900"
                style={{width: "70%", height:"auto", backgroundColor: "#EEEEEE", marginTop: "50px"}}/>
            </div>
          }
          {active === "history" && <div><ProjectBmsHistory /></div>}
        </div>

        </div>
      </section>
    </>
  );
};

export default Project_bms;
